import { render, staticRenderFns } from "./PayableRateAddByCustomer.vue?vue&type=template&id=4adcdda7&scoped=true"
import script from "./PayableRateAddByCustomer.vue?vue&type=script&lang=js"
export * from "./PayableRateAddByCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adcdda7",
  null
  
)

export default component.exports